export default __webpack_public_path__ + "static/media/arrow.da6a260a.svg";